<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Location Status</h4>
          <div style="float: right">
          <vs-button @click="exportExcel">Export</vs-button>
        </div>
      </div>
      <div style="float: right" class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-right">
        
      </div>
    <div style="margin-top: 40px" class="vx-row">
      <div class="vx-col w-1/3">
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Warehouse ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                >
                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Location ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.location_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, location)"
                >
                    <vs-select-item v-for="(item, index) in location.data" :key="index" :value="item.id" :text="item.location_code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Location Type</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.location_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, location_type)"
                >
                    <vs-select-item v-for="(item, index) in location_type.data" :key="index" :value="item.id" :text="item.code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Def. Client ID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Section</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                    class="selectExample"
                    v-model="form.section_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, section)"
                  >
                    <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
                </vs-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Pick Block Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <v-select
                    :options="pickBlockOptions"
                    v-model="form.pick_block"
                    :reduce="option => option.value"
                    class="mb-3"
                    :clearable="false"
                ></v-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Put Block Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                 <v-select
                    :options="putBlockOptions"
                    v-model="form.put_block"
                    :reduce="option => option.value"
                    class="mb-3"
                    :clearable="false"
                ></v-select>
              </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                  <span>Occupied Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      :options="occupiedStatusOptions"
                      v-model="form.pick_block"
                      :reduce="option => option.value"
                      class="mb-3"
                      :clearable="false"
                    ></v-select>
              </div>
          </div>
      </div>
    </div>
      
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      pickBlockOptions: [
          {
              value: 2,
              label: '(Any)'
          },
          {
              value: 1,
              label: 'Blocked'
          },
          {
              value: 0,
              label: 'Unblocked'
          }
      ],
      putBlockOptions: [
          {
              value: 2,
              label: '(Any)'
          },
          {
              value: 1,
              label: 'Blocked'
          },
          {
              value: 0,
              label: 'Unblocked'
          }
      ],
      occupiedStatusOptions: [
          {
              value: 2,
              label: '(Any)'
          },
          {
              value: 1,
              label: 'Occupied'
          },
          {
              value: 0,
              label: 'Empty'
          }
      ],
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      isLoading: false,
      form: {
        warehouse_id: null,
        location_id: null,
        client_id: null,
        location_type_id: null,
        section_id: null,
        pick_block: 2,
        put_block: 2,
        occupied_status: 2,
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
      location: {
        data: [],
        loading: false,
        endpoint: 'master/locations',
        objectKey: 'location_code'
      },
      location_type: {
        data: [],
        loading: false,
        endpoint: 'master/locationtypes',
        objectKey: 'code'
      },
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      section: {
        data: [],
        loading: false,
        endpoint: 'master/sections',
        objectKey: 'section_code'
      },
      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("report/locationstatus", this.form)
        .then(() => {
          this.isLoading = false;
          this.form = {
            warehouse_id: null,
            location_id: null,
            client_id: null,
            location_type_id: null,
            section_id: null
          };
          this.$vs.notify({
            color: "success",
            title: "Data Added",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Added"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
      this.$http.post("report/locationstatus"),
      this.$http.post("master/warehouses"), 
      this.$http.post("master/locations"), 
      this.$http.post("master/locationtypes"),
      this.$http.post("master/clients"),
      this.$http.post("master/sections") 
      ])
        .then(
          this.$http.spread((resp, warehouse, location, locationtypes, client, section) => {
            this.data = resp.data.data;
            this.warehouse.data = warehouse.data.data;
            this.location.data = location.data.data;
            this.location_type.data = locationtypes.data.data;
            this.section.data = section.data.data;
            this.client.data = client.data.data;
            this.totalPage = resp.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = resp.data.total;
            this.dataFrom = resp.data.from;
            this.dataTo = resp.data.to;
          })
        )
        .catch(() => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    exportExcel() {
      // this.currentPage = 1;
      this.fetchData();
      this.isLoading = true;
      if(this.form.pick_block == 2){
        this.form.pick_block = 1;
        this.form.pick_block = 0;
      }
      if(this.form.put_block == 2){
        this.form.put_block = 1;
        this.form.put_block = 0;
      }
      if(this.form.occupied_status == 2){
        this.form.occupied_status = 1;
        this.form.occupied_status = 0;
      }
      
      this.$http
        .post("report/locationstatus", this.form, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "location-status-export.xlsx");
        });
    },
    
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
  this.columnDefs = [
    {
      headerName: "Warehouse Code",
      field: "warehouses_code",
      width: 150,
    }
  ];
}
};
</script>